export const numpadValueValidation = (betAmount, limits, setBetAmount) => {
  const { minBet, maxBet } = limits || {};
  const validAmount = Math.min(Math.max(+betAmount || 0, minBet || 0), maxBet || 0);
  setBetAmount(validAmount);
};
